import { render } from "./OftalmologiaForm.vue?vue&type=template&id=59cf71cd&scoped=true"
import script from "./OftalmologiaForm.vue?vue&type=script&lang=js"
export * from "./OftalmologiaForm.vue?vue&type=script&lang=js"

import "@/assets/css/listaRegistros.css?vue&type=style&index=0&id=59cf71cd&scoped=true&lang=css"
import "@/assets/css/especialidades.css?vue&type=style&index=1&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59cf71cd"]])

export default __exports__